import type React from "react";

const DsEmptyState: React.FC = () => (
  <>
    <div className={`data-table-row`}>
      <div className={`data-table-cell integration-content is-loading`}>
        <div className="loading-row" />
      </div>
      <div className={`data-table-cell update-content is-loading`}>
        <div className="loading-row" />
      </div>
    </div>
    <div className={`data-table-row`}>
      <div className={`data-table-cell integration-content is-loading`}>
        <div className="loading-row" />
      </div>
      <div className={`data-table-cell update-content is-loading`}>
        <div className="loading-row" />
      </div>
    </div>
    <div className={`data-table-row`}>
      <div className={`data-table-cell integration-content is-loading`}>
        <div className="loading-row" />
      </div>
      <div className={`data-table-cell update-content is-loading`}>
        <div className="loading-row" />
      </div>
    </div>
  </>
);

export default DsEmptyState;
